import React from 'react';
import Button from '../../ui/button/button';
import './cartSummary.css';


export function CartCheckout({config, onSubmit, isSubmitting}) {
  const { button } = config;

  return (
    <div className='neo-cart-checkout'>
      <Button label={button.title} onClick={onSubmit} isLoading={isSubmitting}/>
    </div>
  );
}

function Transaction({ transaction }) {
  function getRowColor(type) {
    switch(type) {
      case "subtotal":
      case "total_vat_excluded":
      case "subtotal_before_reduction":
        return "purchase";
      case "credit": 
      case "discount":
        return "credit";
      case "total":
        return "total";
      default:
        return "default";
    }
  }

  return (
    <div className={`transaction-row ${getRowColor(transaction?.type)}`}>
      <span className='label'>{transaction?.label}</span>
      <span className='amount'>
        {transaction?.amount_formatted}
      </span>
    </div>
  )
}

export default function CartSummary({config}) {
    const { title } = config;
    const transactions = config.cart_details.transaction_rows_details;

    const indexRowTotal = React.useMemo(() => transactions.indexOf(transactions.find(t => t.type === "total")),[transactions]);
    const beforeTotal = React.useMemo(() => transactions.slice(0, indexRowTotal), [transactions, indexRowTotal]);
    const totalAndAfter = React.useMemo(() => transactions.slice(indexRowTotal), [transactions, indexRowTotal]);

    return (
        <div className='neo-cart-summary'>
            <h1 className='step-title'>{title}</h1>
            <div className='transactions'>
              <div className='fees-credits-purchases-rows'>
                {beforeTotal.map((transaction, index) => (
                  <Transaction transaction={transaction} />
                ))}
              </div>
              <div className='total-rows'>
                {totalAndAfter.map((transaction, index) => (
                  <Transaction transaction={transaction} />
                ))}
              </div>
            </div>
        </div>
    )
}